import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";
import { formatMoney, VAT_RATES, UNITS } from "@/lib/format";
import { toast } from "sonner";

export default function Products() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: "", unit: "adet", price: 0, vat_rate: 20, description: "" });
  const load = async () => setItems((await api.get("/products")).data);
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name) { toast.error("Ad zorunlu"); return; }
    const body = { ...form, price: Number(form.price), vat_rate: Number(form.vat_rate) };
    try {
      if (editing) await api.put(`/products/${editing.id}`, body);
      else await api.post("/products", body);
      toast.success("Ürün kaydedildi");
      setOpen(false); setEditing(null);
      setForm({ name: "", unit: "adet", price: 0, vat_rate: 20, description: "" });
      load();
    } catch { toast.error("Kaydedilemedi"); }
  };
  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/products/${id}`); load();
  };
  const openEdit = (p) => { setEditing(p); setForm({ name: p.name, unit: p.unit, price: p.price, vat_rate: p.vat_rate, description: p.description || "" }); setOpen(true); };
  return (
    <div className="space-y-6" data-testid="products-page">
      <div className="flex items-center justify-between">
        <div><div className="text-xs uppercase tracking-widest text-zinc-500">Katalog</div><h1 className="text-3xl mt-1">Ürünler</h1></div>
        <Button data-testid="new-product-button" onClick={()=>{setEditing(null); setForm({ name:"",unit:"adet",price:0,vat_rate:20,description:"" }); setOpen(true);}} className="bg-zinc-900 hover:bg-zinc-800"><Plus size={16} className="mr-1"/>Yeni Ürün</Button>
      </div>
      <div className="bg-white rounded-md border border-zinc-200 overflow-hidden">
        <table className="acc">
          <thead><tr><th>Ad</th><th>Birim</th><th className="num">Fiyat</th><th className="num">KDV%</th><th>Açıklama</th><th></th></tr></thead>
          <tbody>
            {items.length===0 && <tr><td colSpan={6} className="text-center text-zinc-500 py-8">Henüz ürün yok</td></tr>}
            {items.map(p => (
              <tr key={p.id} data-testid={`product-row-${p.id}`} onClick={()=>openEdit(p)}>
                <td className="font-medium">{p.name}</td>
                <td>{p.unit}</td>
                <td className="num">{formatMoney(p.price)}</td>
                <td className="num">{p.vat_rate}%</td>
                <td className="text-zinc-600">{p.description}</td>
                <td><button onClick={(e)=>{e.stopPropagation(); del(p.id);}} className="text-zinc-400 hover:text-red-600"><Trash2 size={14}/></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editing ? "Ürün Düzenle" : "Yeni Ürün"}</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2"><Label>Ad</Label><Input data-testid="product-name-input" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} /></div>
            <div>
              <Label>Birim</Label>
              <Select value={form.unit} onValueChange={(v)=>setForm({...form, unit: v})}>
                <SelectTrigger data-testid="product-unit-select"><SelectValue /></SelectTrigger>
                <SelectContent>{UNITS.map(u=><SelectItem key={u} value={u}>{u}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Fiyat</Label><Input type="number" step="0.01" value={form.price} onChange={(e)=>setForm({...form, price: e.target.value})} /></div>
            <div>
              <Label>KDV %</Label>
              <Select value={String(form.vat_rate)} onValueChange={(v)=>setForm({...form, vat_rate: Number(v)})}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>{VAT_RATES.map(v=><SelectItem key={v} value={String(v)}>{v}%</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="col-span-2"><Label>Açıklama</Label><Input value={form.description} onChange={(e)=>setForm({...form, description: e.target.value})} /></div>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={()=>setOpen(false)}>İptal</Button>
            <Button data-testid="product-save-button" onClick={save} className="bg-zinc-900 hover:bg-zinc-800">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
